<script setup>

  /**
   * Komponens: Dasboard-ról állítható informciós sáv lekérdezése és megjelenítése
  */

  import { API } from 'aws-amplify';
  import { ListWebshopContentsByCreatedAt } from '~/graphql/query-list-webshop-contents-by-created-at';

  const { componentid } = defineProps(['componentid']);

  const { locale } = useI18n();

  let loading = ref(true);
  let content = ref(null);

  const fetchInfoBar = async() => {
    loading.value = true
    const nowInt = Math.floor(new Date().getTime() / 1000)
    try {
      // get WebshopContent by componentId:
      const variables = {
        componentId: componentid,
        filter: {
          showFromInt: {
            le: nowInt,
          },
          showToInt: {
            ge: nowInt,
          },
        },
        // Ez is működik:
        // filter: {
        //   showFrom: {
        //     le: now,
        //   },
        //   showTo: {
        //     ge: now,
        //   },
        // },
      }
      const dataholder = await API.graphql({
        query: ListWebshopContentsByCreatedAt,
        variables,
        // authMode: 'AWS_IAM',
      })
      // AWSJSON mezők tartalmának parse-olása:
      const webshopContents =
        dataholder.data.ListWebshopContentsByCreatedAt.items.map((data) => {
          const parsedData = JSON.parse(JSON.stringify(data))
          if (parsedData.content) {
            parsedData.content = JSON.parse(parsedData.content)
            // console.log('parsedData.content', parsedData.content)
          }
          return parsedData
        })
        // console.log(webshopContents);
      // nyelv szerinti tartalom kiválasztása:
      if (
        webshopContents[0] &&
        webshopContents[0].content &&
        webshopContents[0].content[locale.value]
      ) {
        content.value = webshopContents[0].content[locale.value]
      }
    } catch (e) {
      console.error(e)
      // bugsnag remote logging:
      // useBugsnag().notify(new Error(e))
    }
    loading.value = false
  };

  await fetchInfoBar();

</script>

<template>
  <div
    v-if="content"
    class="relative md:mt-4 mb-2 py-1 bg-red-dark bg-primary font-sans font-light text-center text-txt-light"
  >
    {{ content }}
  </div>
</template>
